const services = [
  {
    title: 'Configuração de Ferramentas Digitais',
    description: 'Simplifique processos e aumente a eficiência com soluções digitais que falam a linguagem do seu negócio. Vamos dar-lhe as ferramentas certas para que se concentre no que realmente importa: o crescimento.',
    imageUrl: '/images/homepage/illustrations/service-tools-config.webp',
  },
  {
    title: 'Soluções de Fidelização de Clientes',
    description: 'Com programas de fidelização gamificados, criamos estratégias que mantêm os seus clientes próximos e os tornam fiéis. O futuro é digital, e com Plover, o seu negócio cresce com os seus clientes.',
    imageUrl: '/images/homepage/illustrations/service-loyalty-illustration.webp',
  },
  {
    title: 'Consultoria de Estratégia Empresarial',
    description: 'Com uma visão clara e orientada para o futuro, vamos ajudá-lo a desenhar um caminho seguro para a inovação. Desde o planeamento até à execução, oferecemos conselhos práticos e estratégias que fazem a diferença.',
    imageUrl: '/images/homepage/illustrations/service-strategy-illustration.webp',
  },
];

const ServicesOverview = () => {
  return (
    <section className="services section">
      <div className="wrapper wrapper--large">
        <h2 className="wrapper__title">Os Nossos Serviços</h2>

        <div className="row col-3">
          {services.map((service, index) => (
            <div key={index} className="col card">
              <img
                alt=""
                className="card__illustration"
                src={service.imageUrl}
              />
              <h3 className="card__title h5">{service.title}</h3>
              <p className="card__description centered">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;